import React, { useCallback, useState } from 'react';

import { Button, List } from 'antd';

import { Icon } from '@eduzz/ui-antd-theme';

import NutrorForm from '../../Form/Nutror';

interface IProps {
  nutror: any;
  index: any;
  onEdit?: any;
  productId?: number;
  onRemove: any;
}

const Nutror: React.FC<IProps> = ({ nutror, index, onEdit, onRemove }) => {
  const [modal, setModal] = useState(false);

  const openModal = useCallback(() => {
    setModal(true);
  }, []);

  const closeModal = useCallback(() => {
    setModal(false);
  }, []);

  const onOk = useCallback(
    (newItem: any, old: any) => {
      setModal(false);
      if (onEdit) onEdit(newItem, old);
    },
    [onEdit]
  );

  const title = `${nutror.type === 'C' ? 'Curso' : 'Pacote'} via Eduzz Membros`;

  return (
    <>
      <List.Item
        className='border-outline-default mb-3 cursor-pointer rounded-xl border bg-(--uizz-antd-color-bg-container) px-4 py-3'
        onClick={openModal}
        actions={[
          <Button
            key='remove'
            type='text'
            className='m-0'
            icon={<Icon.Trash2 size={16} className='size-4' />}
            onClick={e => {
              e.stopPropagation();
              onRemove(nutror.nutror_name, index);
            }}
          />
        ]}
      >
        <List.Item.Meta
          className='items-center'
          avatar={
            <div className='flex size-10 shrink-0 items-center justify-center'>
              <img src='/img/eduzz-icon.svg' alt='' className='h-10 w-full object-contain' />
            </div>
          }
          title={title}
          description={nutror.nutror_name}
        />
      </List.Item>
      {modal && <NutrorForm nutror={nutror} isModal={true} open={modal} onClose={closeModal} onOk={onOk} />}
    </>
  );
};

export default Nutror;
